import { Coordinates } from '../types/collectionPoints';
import { SimpleAddress } from './checkoutState';

const getCoordinates = (
  result: google.maps.places.PlaceResult | google.maps.GeocoderResult
): Coordinates | undefined => {
  const location = result.geometry?.location;
  if (!location) {
    return undefined;
  } else {
    return { latitude: location.lat(), longitude: location.lng() };
  }
};

export const getAddress = (
  result: google.maps.places.PlaceResult | google.maps.GeocoderResult
): Partial<SimpleAddress & { coordinates: Coordinates }> => {
  const getAddressComponent = (type: string, useShortName?: boolean) =>
    result.address_components!.find(component => component.types.includes(type))?.[
      useShortName ? 'short_name' : 'long_name'
    ];

  const street = getAddressComponent('route', true);
  const houseNumber = getAddressComponent('street_number');
  const zipCode = getAddressComponent('postal_code');
  const city = getAddressComponent('locality') ?? getAddressComponent('postal_town');
  const coordinates = getCoordinates(result);

  return { street, houseNumber, zipCode, city, coordinates };
};
